import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import UserAdTypes from './constants'

import * as adminUserActions from './actions'

const getuserAdListState = state => state.userAdList;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function loadUsersApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.LOAD_USERS_API, 
    formData
  )

  return handleRequest(request);
}
function listRequestApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.LIST_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemRequestApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.ITEM_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemAddRequestApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.ITEM_ADD_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemUpdateRequestApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.ITEM_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function adminUserItemRemoveRequestApi (formData) {
  const request = axiosApi().post(
    UserAdTypes.ITEM_REMOVE_API, 
    formData
  )

  return handleRequest(request);
}

function* loadUsers ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(loadUsersApi, payload)
    // dispatch the action with our widgets!
    yield put(adminUserActions.setUsers(results.data))
  } catch (error) {
    yield put(adminUserActions.userAdListError(error))
  }
}
function* userAdListRequestFlow ({payload}) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(adminUserActions.userAdListSuccess(results.data))
  } catch (error) {
    yield put(adminUserActions.userAdListError(error))
  }
}

function* adminUserItemRequestFlow () {
  const userAdList = yield select(getuserAdListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemRequestApi, userAdList.formData);
    // dispatch the action with our widgets!
    yield put(adminUserActions.adminUserItemSuccess(results.data));
  } catch (error) {
    yield put(adminUserActions.adminUserItemError(error));
  }
}

function* adminUserItemAddRequestFlow (action) {
  const userAdList = yield select(getuserAdListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemAddRequestApi, userAdList.formData)
    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemAddError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemAddSuccess(results));
    }
  } catch (error) {
    yield put(adminUserActions.adminUserItemAddError(error))
  }
}

function* adminUserItemUpdateRequestFlow () {
  const userAdList = yield select(getuserAdListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemUpdateRequestApi, userAdList.formData)

    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemUpdateError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemUpdateSuccess(results));
    }

  } catch (error) {
    yield put(adminUserActions.adminUserItemUpdateError(error))
  }
}

function* adminUserItemRemoveRequestFlow () {
  const userAdList = yield select(getuserAdListState);
  try {
    // grab the client from our action
    const results = yield call(adminUserItemRemoveRequestApi, userAdList.formData)

    if (results.code != 200) {
      yield put(adminUserActions.adminUserItemRemoveError(results.message));
    }
    else {
      // dispatch the action with our widgets!
      yield put(adminUserActions.adminUserItemRemoveSuccess(results.message));
    }

  } catch (error) {
    yield put(adminUserActions.adminUserItemRemoveError(error));
  }
}

function* userAdWatcher () {
  yield [
    takeLatest(UserAdTypes.LOAD_USERS, loadUsers),
    takeLatest(UserAdTypes.LIST_REQUESTING, userAdListRequestFlow),
    takeLatest(UserAdTypes.ITEM_REQUESTING, adminUserItemRequestFlow),
    takeLatest(UserAdTypes.ITEM_ADD_REQUESTING, adminUserItemAddRequestFlow),
    takeLatest(UserAdTypes.ITEM_UPDATE_REQUESTING, adminUserItemUpdateRequestFlow),
    takeLatest(UserAdTypes.ITEM_REMOVE_REQUESTING, adminUserItemRemoveRequestFlow),
  ]
}

export default userAdWatcher



// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/sagas.js